import styled from 'styled-components';


export const PanInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:2rem;
    `
);

export const PanCardInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        
    `
);

export const PanCardInfoHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        position:relative;

        span{
            position: absolute;
            top:50%;
            right:0;
            width:85%;
            height:0.1rem;
            background-color: rgba(0,0,0,0.5);
        }

        @media(max-width:1023px){
            span{
                width:75%;
            }
        }
    `
);

export const PanCardInfoHeadText = styled.p(
    props => `
        font-size: 1.2rem;
        color: #4c4c4c;
        font-weight: bold;
        text-transform: uppercase;
    `
);

export const PanCardInfoMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top:2rem;
        flex-direction: column;
    `
);

export const PanCardInfoRowWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 2rem;
        @media(max-width:1023px){
            flex-direction: column;
        }
    `
);

export const AgencyNameInputWrap = styled.div(
    props => `
        width:58%;
        display: flex;
        flex-direction: column;
        position: relative;
        @media(max-width:1023px){
            width:100%;
        }
    `
);

export const PanCardNumberInputWrap = styled.div(
    props => `
        width:40%;
        display: flex;
        flex-direction: column;
        position: relative;
        @media(max-width:1023px){
            width:100%;
            margin-top:1.5rem;
        }
    `
);

export const UploadPicInfoWrap = styled.div(
    props => `
        width:58%;
        display: flex;
        flex-direction: column;
        @media(max-width:1023px){
            width:100%;
        }
    `
);

export const UploadPanHeadText = styled.p(
    props => `
        font-size: 1.6rem;
        color: #000;
        font-weight:bold;
    `
);

export const UploadPanSubText = styled.span(
    props => `
        padding-top: 0.4rem;
        font-size: 1.2rem;
        color: #000;
    `
)

export const UploadBlockWrap = styled.div(
    props => `
        width:40%;
        display: flex;
        flex-direction: column;
        margin-top:1.5rem;
        @media(max-width:1023px){
            width:100%;
        }
    `
);

export const InfoToolTip = styled.div(
    props =>`
        height: auto;
        max-width: 25rem;
        padding: 1rem;
        background-color: ${props.theme.colors.grey.dark3e};
        position: absolute;
        top: 100%;
        left: 3.5rem;
        z-index: ${props.theme.misc.zIndex.xxlarge};
        border-radius: ${props.theme.misc.borderRadius.base};
        color: ${props.theme.colors.white.base};
        font-size: ${props.theme.font.large.font14};
        box-shadow: 0px 0px 3px 0px ${props.theme.colors.black.light3};
        transition: all 0.25s ease-out;

        &:before {
            content: '';
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid ${props.theme.colors.grey.dark3e};
            top: -0.8rem;
            position: absolute;
    }
`);

export const UploadLabel = styled.label(
    props =>`
    width: 100%;
    display: flex;
    border: 1px dashed ${props.theme.colors.blue.light36};
    background-color: ${props.theme.colors.blue.light06};
    height: 4.2rem;
    border-radius: ${props.theme.misc.borderRadius.base};
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    margin-top:1rem;
  
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: ${props.theme.spacing.base};
      width: 100%;
      margin-left: 0rem;
      height: 6rem;
    }
    opacity: ${props.disabled ? '0.2' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
`);

export const FullDiv = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const UploadImgMainText = styled.p(
  props => `
        display:inline-block;
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        text-align:center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width:95%;
    `,
);

export const BoldText = styled.span(
    props => `
          font-weight: ${props.theme.font.fontWeight.black};
          padding-left: ${props.theme.spacing.small.s3};
          padding-right: ${props.theme.spacing.small.s3};
      `,
);

export const SubInfoText = styled.span(
    props => `
        font-size: 1.2rem ${props.theme.font.base};
        color: ${props.theme.colors.grey.light07};
        padding-top:${props.theme.spacing.small.s3};
    `,
);

export const UploadFile = styled.input.attrs({type: 'file'})(
    props => `
        width:100%;
        display: flex;
        -webkit-appearance:none;
        display:none;
    `,
);

export const KycLabelWrap = styled.div(
    props =>`
      width: 100%;
      display: flex;
      flex-direction: column;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        width: 100%;
        margin-left: 0;
      }
`);

export const PanCardNameInfoWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: center;
    `
)

export const PanCardNameInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};;
        line-height: ${props.theme.font.lineHeight.large};
    `
);
  